export const TIMEBREAKS = 'timebreaks';
export const TIMECARDS = 'timecards';
export const SHIFTS = 'shifts';
export const CLOCKED_IN = 'clocked_in';
export const CLOCKED_OUT = 'clocked_out';
export const CLOCKED_IN_BREAK = 'clocked_in_break';
export const CLOCKED_OUT_BREAK = 'clocked_out_break';
export const SUCCESS_VIEW_AUTO_CLOSE_SECONDS = 3;
